export default __webpack_public_path__ + "static/media/prevArrow.f3bd2757.svg";